const Blog = () => {
    return(
        <div>
             u can write blog of this web camp this web
        </div>
    )
}
export default Blog;